import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class HeaderContainer extends ThemeComponent {
    @Prop({default: window.pageYOffset}) scrollPosition!: number;

    @Ref() mobileMenuToggle!: HTMLElement;
    @Ref() cartQuantity!: HTMLElement;

    mobileMenu: HTMLElement|null = null;

    init() {

        // Handle mobile menu toggle
        this.handleMobileMenuToggle();

        // Handle cart quantity update
        this.$subscribe(cart.onChange, () => this.cartQuantityUpdate());
    }

    handleMobileMenuToggle() {

        // Get mobile menu
        this.mobileMenu = document.querySelector('.mobile-menu');

        // Give initial value for scrollPosition
        this.scrollPosition = window.pageYOffset;

        // Init click event listeners
        this.initMobileMenuToggleClickEventListener();

        // Init navigation breakpoint check
        this.mobileMenuMatchMedia();
    }

    initMobileMenuToggleClickEventListener() {
        this.$listen(this.mobileMenuToggle, 'click', () => {

            // Ensure mobile menu exist
            if (this.mobileMenu === null) {
                this.$log.error(`Mobile menu element not found`);
                return;
            }

            // Toggle classes
            this.mobileMenu.classList.toggle('mobile-menu--active');

            // Determine open state
            if (this.mobileMenu.classList.contains('mobile-menu--active')) {

                // Disable body scrolling
                this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
            } else {

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);
            }
        });
    }

    mobileMenuMatchMedia() {
        // Remove mobile menu active active if greater than $navigation-breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 1060px)`);

        // Check breakpoint, remove mobile menu classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Remove classes
                if (this.mobileMenu) {
                    this.mobileMenu.classList.remove('mobile-menu--active');
                }

                // Enable scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }

    cartQuantityUpdate() {
        const count = cart.getCartItemCount();
        this.cartQuantity.textContent = `${count}`;
        if (count > 0) {
            this.cartQuantity.classList.add('cart-item-count--has-items');
        } else {
            this.cartQuantity.classList.remove('cart-item-count--has-items');
        }
    }
}
